import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const languages = ['Suomeksi', 'På svenska', 'In English'];

class LanguageMenu extends React.Component {
  constructor(props) {
    super(props);
    let index = 0;
    if(props.strings.getLanguage() == 'en') {
      index = 2;
    }else if(props.strings.getLanguage() == 'sv') {
      index = 1;
    }
    this.state = {
      anchorEl: null,
      selectedIndex: index,
    };
    this.strings = props.strings;
    this.setLanguage = props.setLanguage;
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    if (index === 0) {
      this.setLanguage('fi');
    } else if(index === 1) {
      this.setLanguage('sv');
    } else {
      this.setLanguage('en');
    }
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <Button
          color="inherit"
          aria-owns={anchorEl ? 'language-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          {languages[this.state.selectedIndex]}
        </Button>
        <Menu
          id="language-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {languages.map((language, index) => (
            <MenuItem 
              key={language}
              selected={index === this.state.selectedIndex}
              onClick={event => this.handleMenuItemClick(event, index)}

            >
              {language}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

export default LanguageMenu;

